import React, { FC, useState, useEffect } from 'react';

interface IInput {
    id: string;
    type?: string;
    name: string;
    placeholder: string;
    label?: string;
    value: string;
    customStyle?: any;
    setFormData: (state: any) => void;
    error?: string;
    setFormErrors: (state: any) => void;
}

const Input: FC<IInput> = ({ id, name, placeholder, label, value, customStyle, setFormData, error, setFormErrors, type }: IInput) => {
    const [ inputValue, setInputValue ] = useState<string>('');

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setInputValue(event.target.value);

        setFormData((state: any) => {
            return {
                ...state,
                [name]: event.target.value,
            }
        });

        setFormErrors && setFormErrors((state: any) => {
            return {
                ...state,
                [name]: ''
            }
        });
    };

    return (
        <div
            className="new-input"
            style={customStyle ? customStyle : {}}
        >
            <label
                className="new-input__label"
                htmlFor={id}
            >
                {label && <span className="new-input__label-text">{label}</span>}
                <input
                    className={`new-input__element ${error ? 'error' : ''}`}
                    type={type ?? 'text'}
                    id={id}
                    name={name}
                    value={inputValue ?? ''}
                    placeholder={placeholder}
                    onChange={onChangeHandler}
                />
            </label>
            {error
                ?
                <p className="new-input__error">
                    {error}
                </p>
                :
                <></>
            }
        </div>
    );
};

export default React.memo(Input);
